import { useMatchRoute } from "@tanstack/react-router";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ListItemButton, Typography, useTheme } from "@mui/material";
import { RouteLink, StyledAnchor } from "@/components/common/styles";
import CircleIcon from "@mui/icons-material/Circle";
import { NavItemType, NavItemVariants } from "./types";
import checkIfItemSelected from "./utils/checkIfItemSelected";

import MenuIcon from "./MenuIcon";

type NavItemProps = NavItemType & {
  autoCloseDrawer: () => void;
  variant?: NavItemVariants;
};

export default function NavItem(props: NavItemProps) {
  const {
    title,
    autoCloseDrawer,
    icon,
    variant = "list-item",
    status,
    testId,
  } = props;
  const theme = useTheme();
  const matchRoute = useMatchRoute();
  const selected = checkIfItemSelected(matchRoute, props);

  const button =
    variant === "button" ? (
      <ListItemButton
        sx={{ paddingLeft: "8px", paddingRight: "8px" }}
        onClick={autoCloseDrawer}
        selected={selected}
        data-testid={testId}
      >
        {icon && (
          <ListItemIcon>
            <MenuIcon icon={icon} selected={selected} />
          </ListItemIcon>
        )}
        <ListItemText
          color="text.primary"
          primary={title}
          sx={[
            icon
              ? {
                  pl: 0,
                }
              : {
                  pl: 6,
                },
          ]}
        />
      </ListItemButton>
    ) : (
      <ListItemButton
        sx={{ paddingLeft: "12px", paddingRight: "8px" }}
        onClick={autoCloseDrawer}
        data-testid={testId}
      >
        <ListItemIcon sx={{ minWidth: "36px" }}>
          <CircleIcon
            sx={{ width: "6px", height: "6px", ml: 4 }}
            style={{
              color: selected
                ? theme.palette.primary.main
                : theme.palette.grey[300],
            }}
          />
        </ListItemIcon>
        <ListItemText
          color="text.primary"
          disableTypography
          primary={
            <Typography
              fontSize="16px"
              variant="body2"
              color="text.primary"
              noWrap
              sx={[
                selected
                  ? {
                      fontWeight: 600,
                    }
                  : {
                      fontWeight: 400,
                    },
              ]}
            >
              {title}
            </Typography>
          }
        />
        {status}
      </ListItemButton>
    );

  return (
    <ListItem key={"key-list-sub-item-" + title} disablePadding>
      {props.external ? (
        <StyledAnchor href={props.href} style={{ flex: 1 }} target="_blank">
          {button}
        </StyledAnchor>
      ) : (
        <RouteLink to={props.to} params={props.params} style={{ flex: 1 }}>
          {button}
        </RouteLink>
      )}
    </ListItem>
  );
}
